module.exports = __webpack_public_path__ + "img/pr-23.3e6ccb1f.png";